import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";

import { ButtonToolbar } from "react-bootstrap";

import { isEnabled } from "utils/featureFlags";

import { Button, ButtonGroup, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";

import styles from "./style.module.css";

const HeaderTab = (props) => {
  const { title, icon, isActive, onClick, isDisabled, style } = props;
  return (
    <div
      className={
        styles.headerTab +
        " " +
        (isActive ? styles.headerTabActive : "") +
        " " +
        (isDisabled ? styles.headerTabDisabled : "")
      }
      onClick={onClick}
      style={style ? style : {}}
    >
      {icon && <div className={styles.headerTabIcon}>{icon}</div>}
      <div className={styles.headerTabTitle} title={title}>
        {title}
      </div>
    </div>
  );
};

export default HeaderTab;
